import { j as e } from "../../../../jsx-runtime-B6kdoens.js";
import { forwardRef as a } from "react";
import { I as i } from "../../../../IconBase-CxZyIWw2.js";
const s = a((o, r) => /* @__PURE__ */ e.jsx(
  i,
  {
    ref: r,
    ...o,
    image: (l) => /* @__PURE__ */ e.jsx(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 16,
        height: 16,
        fill: "none",
        viewBox: "0 0 16 16",
        ...l,
        children: /* @__PURE__ */ e.jsx(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M11 7a4 4 0 1 0-8 0 4 4 0 0 0 8 0M7 1a6 6 0 0 1 4.89 9.477l3.067 3.066-1.414 1.414-3.066-3.066A6 6 0 1 1 7 1",
            clipRule: "evenodd"
          }
        )
      }
    )
  }
));
s.displayName = "SearchIcon";
export {
  s as SearchIcon,
  s as default
};
//# sourceMappingURL=index.js.map
